import { NextPage } from 'next';
import React from 'react';
import FdrPageComponentsWithRequestButton from 'components/domain/fdr-page-components/fdr-page-components-with-request-button';
import {
  fdrThemePageComponentsVars,
  fdrThemePageVars,
} from 'components/page/theme/theme.vars';
import { useFdrThemeContentQuery } from 'schemas/query/theme/fdr-theme-content.generated';
import { useFdrThemePageComponentQuery } from 'schemas/query/theme/fdr-theme-page-components.generated';

export { getServerSideProps } from 'components/page/theme/theme.gssp';

const THEME_OVERVIEW_REQUEST_BUTTON_BG_COLOR = '#7A2739';

interface IThemePageProps {
  id: string;
}

const ThemePage: NextPage<IThemePageProps> = ({ id }) => {
  const { data } = useFdrThemeContentQuery({
    variables: {
      input: { publicId: id },
      ...fdrThemePageVars,
    },
  });

  const { data: pageComponents } = useFdrThemePageComponentQuery({
    variables: {
      input: { publicId: id },
      ...fdrThemePageComponentsVars,
    },
  });

  return (
    <FdrPageComponentsWithRequestButton
      components={pageComponents?.fdrTheme?.pageComponents.components}
      requestButton={data.fdrTheme?.requestButton}
      requestButtonBgColor={THEME_OVERVIEW_REQUEST_BUTTON_BG_COLOR}
    />
  );
};

export default ThemePage;
